export const EMPTY_ITEM = {
  description: '',
  quantity: 1,
  rate: 0,
  amount: '',
  taxPercentage: '',
}
